<div>
  <!-- Breadcrumbs section -->
  <eds-panel theme="dark" [edsSpacing]="'none'">
    <div edsGrid edsPadding edsPaddingLeft="xs">
      <div edsRow>
        <div edsCol>
          <eds-breadcrumbs [items]="breadcrumbItems" theme="dark">
          </eds-breadcrumbs>
        </div>
      </div>
    </div>
  </eds-panel>

  <!-- Filter(s) section -->
  <ft-us-capital-gains-estimates-filters
    [filters]="filters"
    [recordDetails]="recordDetails"
    (filterListing)="onFilterApplied($event)"
    (hideFundsToggle)="onHideFundsToggle($event)"
    (favoritesOnlyToggle)="onFavoritesOnlyToggle($event)"
    [hideFundsSwitchState]="hideFundsSwitchState"
    [showFavoritesOnlySwitch]="showFavoritesOnlySwitch"
    [favoritesOnlySwitchState]="favoritesOnlySwitchState"
  ></ft-us-capital-gains-estimates-filters>

  <!-- Enclose everything else within appropriate left-right padding -->
  <div edsGrid>
    <!-- Content info and action section -->
    <div
      id="capGainsScrollPoint"
      edsPadding
      [edsPaddingBottom]="(isHandheld$ | async) ? 'md' : 'none'"
    >
      <!-- First row -->
      <div edsRow edsSpacing="md">
        <!-- Caveat top -->
        <!-- Show the caveat at full width when 'favoritesOnlySwitch' isn't present, else follow grid division. -->
        <div edsCol [columnNumbers]="proximalTopColumnNumbers">
          <eds-proximal
            edsSpacing="lg"
            placement="CapGainsPageProximalTop"
          ></eds-proximal>
        </div>
      </div>

      <!-- Second row -->
      <!-- Favorites only switch button -->
      <div edsRow edsSpacing="md">
        <div
          edsCol
          edsFlexbox
          [flexDirection]="(isHandheld$ | async) ? 'column' : 'row'"
          justifyContent="space-between"
          alignItems="baseline"
        >
          <eds-title
            [level]="5"
            theme="basic"
            size="h5"
            edsPadding
            [edsPaddingLeft]="(isHandheld$ | async) ? 'sm' : 'none'"
            [edsPaddingBottom]="(isHandheld$ | async) ? 'sm' : 'none'"
          >
            {{ "products.cap-gains-estimates-title" | translate }}
            {{ asOfDate }}</eds-title
          >
          <div
            edsFlexbox
            justifyContent="flex-end"
            [flexDirection]="(isHandheld$ | async) ? 'column' : 'row'"
          >
            <!-- Download all action button -->
            <div
              edsPadding
              [edsPaddingLeft]="(isHandheld$ | async) ? 'sm' : 'none'"
              [edsPaddingRight]="(isHandheld$ | async) ? 'sm' : 'none'"
            >
              <button
                edsButton="secondary"
                [hasIcon]="true"
                [noMargin]="'true'"
                size="normal"
                (click)="onDownloadAction()"
              >
                <span class="ft__btn__txt">{{
                  "products.capgains-excel-download-all-button" | translate
                }}</span>
                <eds-icon type="download" size="small"></eds-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Listing section -->
    <div edsRow>
      <div edsCol>
        <ft-us-capital-gains-estimates-listing
          *ngIf="isLoaded; else noCapGainsData"
          [gridListing]="currentPage$ | async"
          [totalSelectedRows]="totalSelectedRows"
          [gridRowsCount]="recordDetails.filtered"
          (updateNodeSelection)="onRowSelected($event)"
          (sortColumn)="onSortChanged($event)"
          [asOfDate]="asOfDate"
        ></ft-us-capital-gains-estimates-listing>
      </div>
    </div>

    <!-- Pagination/page size action panel -->
    <div edsRow>
      <div edsCol>
        <div
          *ngIf="totalPages"
          edsFlexbox
          [flexDirection]="(isHandheld$ | async) ? 'column' : 'row'"
          [alignItems]="(isHandheld$ | async) ? '' : 'center'"
          justifyContent="space-between"
          edsPadding
          edsPaddingTop="lg"
          edsPaddingBottom="xxl"
        >
          <!-- Pagination selection -->
          <eds-pagination
            edsFlexItem
            [alignSelf]="(isHandheld$ | async) ? 'flex-end' : ''"
            [edsSpacing]="(isHandheld$ | async) ? 'xl' : ''"
            [pages]="totalPages"
            [activePage]="currentPageNumber$ | async"
            (pageChanged)="onPageChanged($event)"
            [prevPageText]="'products.previous' | translate"
            [nextPageText]="'products.next' | translate"
            [ariaLabelGoToPage]="'products?.ariaLabelGoToPage' | translate"
          ></eds-pagination>

          <!-- Page size dropdown -->
          <eds-dropdown
            ariaLabel="Dropdown"
            [dropdownId]="'ItemsPerPageBottomDD'"
            name="BottomDropDown"
            [items]="pageSizeItems"
            [label]="'products.items-per-page' | translate"
            [preselectedValue]="selectedPageSizeItem"
            edsPadding
            edsPaddingLeft="none"
            (dropdownChange)="onPageSizeChanged($event)"
          ></eds-dropdown>
        </div>
      </div>
    </div>

    <!-- Loader/Error info section -->
    <div edsRow>
      <div edsCol>
        <!-- Handle cap gains loading failure -->
        <ng-template #noCapGainsData>
          <p
            class="bold large"
            *ngIf="isLoaded === false; else capGainsDataLoading"
          >
            {{ "products.capgains-loading-failed-message" | translate }}
          </p>
        </ng-template>

        <!-- Show loading message, when state is yet to be loaded -->
        <ng-template #capGainsDataLoading>
          <p class="bold large">
            {{ "products.capgains-loading-message" | translate }}
          </p>
        </ng-template>
      </div>
    </div>

    <!-- Caveat bottom section -->
    <div edsRow>
      <div edsCol>
        <eds-proximal
          edsSpacing="lg"
          placement="CapGainsPageProximalBottom"
        ></eds-proximal>
      </div>
    </div>
  </div>

  <!-- Sticky footer with row count and download option -->
  <eds-sticky-footer
    [itemCount]="totalSelectedRowsAsText"
    [isHide]="totalSelectedRows === 0"
    variation="2"
    [primaryAction]="downloadStickyButton"
    [stickyFooterName]="'capital_gain_sticky_footer'"
    (btnSubscribePrimary)="onDownloadAction(true)"
  ></eds-sticky-footer>
</div>
